<template>
  <div>
    <Form ref="bookForm" :rules="ruleValidate" :model="bookInfo" :label-width="120">
      <div class="title">基本信息</div>
      <FormItem label="图书名称" prop="name">
        <Input
          style="width:300px"
          type="text"
          v-model="bookInfo.name"
          placeholder="请输入图书名称"
          :maxlength="50"
          clearable
        />
      </FormItem>
      <FormItem label="图书作者" prop="author">
        <Input
          style="width:300px"
          type="text"
          v-model="bookInfo.author"
          placeholder="请输入图书作者"
          :maxlength="50"
          clearable
        />
      </FormItem>
      <FormItem label="出版社" prop="publisher">
        <Input
          style="width:300px"
          type="text"
          v-model="bookInfo.publisher"
          placeholder="请输入出版社"
          :maxlength="50"
          clearable
        />
      </FormItem>
      <FormItem label="出版时间" prop="publish_time">
        <DatePicker
          :editable="false"
          type="datetime"
          placeholder="选择出版时间"
          v-model="bookInfo.publish_time"
          format="yyyy-MM-dd HH:mm"
          style="width: 200px"
        ></DatePicker>
      </FormItem>
      <FormItem label="图书简介" prop="instruction">
        <Input
          style="width:500px"
          type="textarea"
          v-model="bookInfo.instruction"
          placeholder="请输入图书简介，最多不超过500个字"
          :maxlength="500"
          :rows="6"
          clearable
        />
      </FormItem>
      <FormItem label="封面图片" prop="cover_img">
        <UploadFile
          url="/api/public/img"
          :format="['jpg','jpeg','gif','png']"
          @onSuccess="onUploadSuccess"
        ></UploadFile>
        <div class="tip">*尺寸为 180 * 240, 请上传jpg, png格式的图片, 建议图片大小不超过2MB。</div>
        <div v-if="bookInfo.cover_img">
          <img :src="bookInfo.cover_img" style="width:90px;height:120px;" />
        </div>
      </FormItem>
      <FormItem label="图书详情" prop="details">
        <UEditor v-model="bookInfo.details"></UEditor>
      </FormItem>
      <FormItem label="赠送积分" prop="gifts_integral">
        <Input
          style="width:300px"
          type="number"
          v-model="bookInfo.gifts_integral"
          placeholder="请输入图书名称"
        />
        <span class="tip">请输入大于0的整数</span>
      </FormItem>
      <FormItem label="是否隐藏">
        <RadioGroup v-model="bookInfo.is_hidden">
          <Radio :label="1">
            <span>是</span>
          </Radio>
          <Radio :label="0">
            <span>否</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="是否包邮">
        <RadioGroup v-model="bookInfo.is_shipping">
          <Radio :label="1">
            <span>是</span>
          </Radio>
          <Radio :label="2">
            <span>否</span>
          </Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="图书重量" prop="weight" v-if="bookInfo.is_shipping == 2">
        <Input
          style="width:120px"
          v-model="bookInfo.weight"
          placeholder="请输入图书重量"
          :maxlength="50"
          :precision="0"
          :min="0"
        />
        <span class="tip">必填，保留两位小数，根据图书的重量判断邮费</span>
        <div class="tip">邮费计算规则：青海省/内蒙/宁夏/甘肃 12元/公斤；西藏/新疆/海南 25元/公斤；其他省份12元/3公斤；每增加一公斤邮费加6元</div>
      </FormItem>
      <div class="title">上架信息</div>
      <FormItem label="所属分类" prop="book_classify_id">
        <Cascader
          :data="classifyList"
          v-model="selectClassify"
          clearable
          @on-change="onClassifyChange"
          style="width:300px;"
          change-on-select
        ></Cascader>
      </FormItem>
      <FormItem label="售卖设置">
        <RadioGroup v-model="bookInfo.is_free">
          <Radio :label="1">
            <span>付费</span>
          </Radio>
          <Radio :label="2">
            <span>免费</span>
          </Radio>
        </RadioGroup>
        <div v-if="bookInfo.is_free==1" style="margin-left:-60px;">
          <FormItem label="图书价格" prop="price" class="form-item-child" style="margin-bottom:24px;">
            <Input style="width:150px" type="text" v-model="bookInfo.price" placeholder="请输入价格" />
            <span class="tip">必须填写大于0的自然数</span>
          </FormItem>
          <FormItem label="划线价格" prop="underlined_price" class="form-item-child">
            <Input
              style="width:150px"
              type="text"
              v-model="bookInfo.underlined_price"
              placeholder="请输入划线价格（选填）"
            />
            <span class="tip">必须填写大于0的自然数</span>
          </FormItem>
        </div>
      </FormItem>
      <FormItem label="图书库存" prop="stock">
        <InputNumber
          style="width:120px"
          type="number"
          v-model="bookInfo.stock"
          placeholder="请输入库存"
          :maxlength="50"
          :min="1"
          :precision="0"
          @keydown.native="intKeydown"
        />
      </FormItem>
      <FormItem label="销售基数" prop="sales_base">
        <InputNumber
          style="width:120px"
          v-model="bookInfo.sales_base"
          placeholder="请输入销售基数"
          :maxlength="50"
          :precision="0"
          :min="0"
        />
        <span class="tip">网站显示数量为（销售基数+实际销售数量）</span>
      </FormItem>
      <FormItem label="浏览基数" prop="browse_base">
        <InputNumber
          style="width:120px"
          v-model="bookInfo.browse_base"
          placeholder="请输入浏览基数"
          :maxlength="50"
          :precision="0"
          :min="0"
        />
        <span class="tip">网站显示数量为（浏览基数+实际浏览数量）</span>
      </FormItem>
      <FormItem style="text-align:center">
        <Button size="large" :to="{name: 'BookManage'}">返回</Button>
        <Button
          size="large"
          style="margin: 0 15px;"
          type="primary"
          @click="submitForm('bookForm')"
        >保存并返回</Button>
      </FormItem>
    </Form>
  </div>
</template>
<script>
import UploadFile from "@/components/UploadFile.vue";
import UEditor from "@/components/UEditor.vue";
import AreaSelect from "@/components/AreaSelect.vue";
export default {
  name: "BookEdit",
  components: {
    UploadFile,
    UEditor,
    AreaSelect
  },
  data() {
    return {
      id: this.$route.query.id,
      bookInfo: {
        name: "",
        author: "",
        publisher: "",
        publish_time: "",
        instruction: "",
        cover_img: "",
        details: "",
        book_classify_id: "",
        is_free: 1,
        price: "",
        underlined_price: "",
        stock: 0,
        sales_base: 0,
        browse_base: 0,
        is_shipping: 1,
        province_id: 0,
        city_id: 0,
        district_id: 0,
        is_hidden: 0,
        gifts_integral: 0,
        weight: 0
      },
      ruleValidate: {
        name: [
          {
            required: true,
            message: "图书名称不能为空",
            trigger: "blur"
          }
        ],
        author: [
          {
            required: true,
            message: "图书作者不能为空",
            trigger: "blur"
          }
        ],
        publisher: [
          {
            required: true,
            message: "出版社不能为空",
            trigger: "blur"
          }
        ],
        publish_time: [
          {
            required: true,
            message: "出版时间不能为空",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("出版时间不能为空"));
              } else {
                callback();
              }
            }
          }
        ],
        cover_img: [
          {
            required: true,
            message: "封面图片不能为空",
            trigger: "blur"
          }
        ],
        weight: [
          {
            required: true,
            message: "图书重量"
          }
        ],
        details: [
          {
            required: true,
            message: "图书详情不能为空",
            trigger: "blur"
          }
        ],
        book_classify_id: [
          {
            required: true,
            message: "所属分类不能为空",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("所属分类不能为空"));
              } else {
                callback();
              }
            }
          }
        ],
        price: [
          {
            required: true,
            message: "图书价格不能为空",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("图书价格不能为空"));
              } else {
                callback();
              }
            }
          },
          {
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value != "" && isNaN(value)) {
                callback(new Error("图书价格必须为数字"));
              } else {
                callback();
              }
            }
          }
        ],
        stock: [
          {
            required: true,
            message: "库存不能为空",
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "") {
                callback(new Error("库存不能为空"));
              } else if (value < 1) {
                callback(new Error("库存必须大于0"));
              } else {
                callback();
              }
            }
          }
        ],
        weight: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              if (value === "" || value === 0) {
                callback(new Error("图书重量不能为空"));
              } else {
                callback();
              }
            }
          }
        ]
      },
      classifyList: [],
      selectClassify: []
    };
  },
  async created() {
    await this.getClassify();
    await this.getData();
  },
  methods: {
    async getClassify() {
      let list = await this.$http.get("/api/course/classify");
      let classifyList = [];
      list.forEach(c => {
        let classify = { value: c.id, label: c.name, children: [] };
        if (c.children) {
          c.children.forEach(child => {
            classify.children.push({ value: child.id, label: child.name });
          });
        }
        classifyList.push(classify);
      });
      this.classifyList = classifyList;
    },
    async getData() {
      if (!this.id) {
        return;
      }
      let data = await this.$http.get("/api/books/" + this.id);
      if (data.price) {
        data.price = data.price / 100;
      }
      if (data.underlined_price) {
        data.underlined_price = data.underlined_price / 100;
      }
      if (data.free_ship > 0) {
        data.is_shipping = 1;
      } else {
        data.is_shipping = 2;
      }
      data.publish_time = new Date(data.publish_time * 1000);
      data.is_free = data.price > 0 ? 1 : 2;
      this.bookInfo = data;
      let classifyList = [];
      for (let i = 0; i < this.classifyList.length; i++) {
        let classify = this.classifyList[i];
        if (classify.value == data.book_classify_id) {
          classifyList.push(classify.value);
          break;
        }
        if (classify.children) {
          let c;
          for (c = 0; c < classify.children.length; c++) {
            let child = classify.children[c];
            if (child.value == data.book_classify_id) {
              classifyList.push(classify.value);
              classifyList.push(child.value);
              break;
            }
          }
          if (c < classify.children.length) {
            break;
          }
        }
      }
      this.selectClassify = classifyList;
    },
    intKeydown(event) {
      if (event.keyCode == 190 || event.keyCode == 189) {
        event.preventDefault();
      }
      if (event.keyCode == 48 && event.target.value == "") {
        event.preventDefault();
      }
      if (event.keyCode == 8) {
        let value = event.target.value;
        if (value.length == 2 && value[0] == "0") {
          event.target.value = "";
          let customEvent = document.createEvent("HTMLEvents");
          customEvent.initEvent("input", false, true);
          event.target.dispatchEvent(customEvent);
        }
      }
    },
    onClassifyChange(value) {
      if (value.length > 0) {
        this.bookInfo.book_classify_id = value[value.length - 1];
      } else {
        this.bookInfo.book_classify_id = "";
      }
      this.$refs.bookForm.validateField("book_classify_id");
    },
    onUploadSuccess(data) {
      this.bookInfo.cover_img = data.path;
    },
    submitForm(ref) {
      this.$refs[ref].validate(async valid => {
        if (!valid) {
          return;
        }
        let data = { ...this.bookInfo };
        if (typeof data.publish_time !== "string") {
          data.publish_time = data.publish_time.format("yyyy-MM-dd hh:mm:ss");
        }
        if (data.is_free == 2) {
          data.price = 0;
          data.underlined_price = 0;
        }
        if (data.is_shipping == 1) {
          data.province_id = 0;
          data.city_id = 0;
          data.district_id = 0;
          data.ship_price = 0;
          data.free_ship = 1;
          data.weight = 0;
        }else {
          data.free_ship = 0;
        }
        if (!data.sales_base) {
          data.sales_base = 0;
        }
        if (!data.browse_base) {
          data.browse_base = 0;
        }
        if (this.id) {
          await this.$http.put("/api/books/" + this.id, data);
        } else {
          await this.$http.post("/api/books", data);
        }
        this.$router.push({ name: "BookManage" });
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.tip {
  color: #8c8c8c;
}
</style>
